import {AsyncPipe} from '@angular/common';
import {Component, ElementRef, OnInit} from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {Observable, take} from 'rxjs';
import {UserService} from '../../../../../core/service/user.service';
import {SpinnerComponent} from '../../../spinner/spinner.component';
import {IconComponent} from '../../../../icon/icon.component';
import {ModalComponent} from '../../modal.component';
import {luidRegex} from "../../../../function/form-validators";
import {IUserInfo} from "../../../../model/userInfo.model";


@Component({
    selector: 'app-impersonate-modal',
    templateUrl: './impersonate-modal.html',
    styleUrls: ['./impersonate-modal.scss'],
    standalone: true,
    imports: [
      AsyncPipe,
      MatInputModule,
      IconComponent,
      SpinnerComponent
    ]
})

export class ImpersonateModalComponent extends ModalComponent implements OnInit {
  public isLoadingUserData$!: Observable<boolean>;
  public impersonationHistory: IUserInfo[] = [];

  public LUID_PATTERN = new RegExp(luidRegex);

  constructor(private userService: UserService, elementRef: ElementRef) {
    super(elementRef);
  }

  ngOnInit(): void {
    this.isLoadingUserData$ = this.userService.isLoadingUserData();
    this.loadHistory();
  }

  public impersonate(email: string) {
    if (!this.isDisabled(email)) {
      this.userService.impersonate(email);
      this.close();
    }
  }

  public isDisabled(email: string): boolean {
    return this.LUID_PATTERN.test(email);
  }

  public impersonateFromHistory(user: IUserInfo): void {
    this.userService.impersonate(user.email);
    this.close();
  }

  public clearHistory(): void {
    this.userService.clearImpersonationHistory().pipe(take(1)).subscribe(() => {
      this.impersonationHistory = [];
    });
  }

  private loadHistory(): void {
    this.userService.getImpersonationHistory().pipe(take(1)).subscribe({
      next: history => {
        this.impersonationHistory = history;
      }
    });
  }
}
